import { BIGGER_FIELD } from "../../../utils/constants";

export const validateAlertState = (
  alertState: any,
): { [key: string]: string } => {
  const errors: { [key: string]: string } = {};

  if (
    alertState.lowestValue &&
    alertState.biggestValue &&
    alertState.lowestValue > alertState.biggestValue
  ) {
    errors["alertState.biggestValue"] = BIGGER_FIELD;
  }

  if (
    alertState.minPeriodVariation &&
    alertState.maxPeriodVariation &&
    alertState.minPeriodVariation > alertState.maxPeriodVariation
  ) {
    errors["alertState.maxPeriodVariation"] = BIGGER_FIELD;
  }

  if (
    alertState.minYearVariation &&
    alertState.maxYearVariation &&
    alertState.minYearVariation > alertState.maxYearVariation
  ) {
    errors["alertState.maxYearVariation"] = BIGGER_FIELD;
  }

  return errors;
};
